(() => {
    document.addEventListener('ProductIndex_TaxonChip_Click', (e) => {
        window.dataLayerPushDeferred({
            event: 'clic_element',
            event_type: 'chip',
            event_detail: e.detail.code.replace('_', '-'),
        });
    });

    document.addEventListener('ProductIndex_GridSelector_Click', (e) => {
        const gridSizesByColumns = {
            mobile: {
                one: 'large',
                two: 'medium',
            },
            desktop: {
                two: 'large',
                three: 'medium',
                four: 'small',
            },
        };

        let device = 'desktop';

        if (window.matchMedia('(max-width: 992px)').matches) {
            device = 'mobile';
        }

        window.dataLayerPushDeferred({
            event: 'change_grid',
            event_type: gridSizesByColumns[device][e.detail.columns],
        });
    });
})();
